import { config, data } from "~/data";

export const getAssetPrefix = () => {
  if (config.general.cdn.enabled) {
    return `https://${config.general.cdn.host}/${config.general.env}`;
  }
  return "";
};

export function isScmpDomain(host: string) {
  return Object.values(data.scmpDomains).some(domain => host.endsWith(domain));
}

export function getAbsoluteUrl(path?: string) {
  if (!path) return config.general.siteUrl;
  try {
    return new URL(path, config.general.siteUrl).href;
  } catch {
    return config.general.siteUrl;
  }
}
